import { t } from "@lingui/macro";
import { MenuList } from "@WahooFitness/redesignr";
import { Box, Container } from "@mui/system";
import { GlobalHeader } from "@WahooFitness/wahoo-offline-mfe";

const DeviceInfo = ({
  firmwareVersion,
  serialNumber,
}: {
  firmwareVersion: string;
  serialNumber: string;
}) => {
  return (
    <>
      <GlobalHeader title={t`Device info`} />
      <Container maxWidth="sm" disableGutters sx={{ minHeight: "100%" }}>
        <Box
          maxWidth="sm"
          width="100%"
          height="100%"
          overflow="scroll"
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <MenuList
            width="100%"
            listItems={[
              {
                id: "firmware-version",
                content: t`ELEMNT version`,
                secondaryContent: firmwareVersion,
              },
              {
                id: "serial-number",
                content: t`ELEMNT serial number`,
                secondaryContent: serialNumber,
              },
            ]}
          />
        </Box>
      </Container>
    </>
  );
};

export default DeviceInfo;
